<template>
  <div class="donut-selector-menu">
    <div v-if="displayStatusText" class="f-v f-jc f-ac p-v10 w-100p">
      <div v-for="(text, i) in displayStatusText" :key="i" class="t gray ital">{{ text }}</div>
    </div>
    <div
      v-for="(option, i) in props.options"
      v-else
      :key="`option-${i}`"
      :tabindex="-1"
      :class="{ 'donut-selector-menu-option': true, 'search-nav-highlighted': i === searchNavIdx }"
      @click.stop="emit('onOptionClick', option)"
    >
      <div class="t">
        <span>{{ option[keyMap.label] }}</span>
        <template v-if="option[keyMap.description]">
          <br>
          <span class="t-sm gray ital">{{ option[keyMap.description] }}</span>
        </template>
      </div>
      <i v-if="isSelected(option, props.keyMap)" class="mi purple md-20">check</i>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const props = defineProps({
    searchQuery: { type: String, default: null },
    options: { type: Array, default: () => [] },
    keyMap: { type: Object, default: null },
    isSelected: { type: Function, required: true },
    emptyMessage: { type: Array, default: () => ['No results'] },
    allowSearch: { type: Boolean, default: true },
    searchNavIdx: { type: Number, default: null },
  });

  const emit = defineEmits(['onOptionClick']);

  const displayStatusText = computed(() => {
    if (state.selector.searching) return ['Loading...'];
    if (!props.allowSearch) {
      // When search is disabled, show options or empty message
      if (!props.options.length) return props.emptyMessage;
      return null; // Don't show any status text, show the options
    }
    if (!props.searchQuery) return ['Start typing to search...'];
    if (!props.options.length) return props.emptyMessage;
  });
</script>
